export default __webpack_public_path__ + "static/Alan.Griffitts_social-a71aee6c0a44ec0548176ea28cbf6a3a.jpg";